import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Login from './components/Login';
import PhotoGrid from './components/PhotoGrid';
import PhotoViewer from './components/PhotoViewer';
import './App.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

function App() {
    const [user, setUser] = useState(null);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [loading, setLoading] = useState(true);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        checkSession();
    }, []);

    const checkSession = async () => {
        try {
            const response = await axios.get(`${API_BASE}/session`, {
                withCredentials: true
            });
            setUser(response.data.user);
        } catch (error) {
            // Not authenticated
            console.log('No active session');
        } finally {
            setLoading(false);
        }
    };

    const handleLoginSuccess = (userData) => {
        setUser(userData);
    };

    const handleLogout = async () => {
        try {
            await axios.post(`${API_BASE}/logout`, {}, {
                withCredentials: true
            });
            setUser(null);
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const handlePhotoClick = (photo) => {
        setSelectedPhoto(photo);
    };

    const handleCloseViewer = () => {
        setSelectedPhoto(null);
    };

    const handlePhotoDeleted = () => {
        setSelectedPhoto(null);
        setRefreshTrigger(prev => prev + 1);
    };

    if (loading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <div className="App">
            {!user ? (
                <Login onLoginSuccess={handleLoginSuccess} />
            ) : (
                <>
                    <PhotoGrid
                        user={user}
                        onPhotoClick={handlePhotoClick}
                        onLogout={handleLogout}
                        refreshTrigger={refreshTrigger}
                    />
                    {selectedPhoto && (
                        <PhotoViewer
                            photo={selectedPhoto}
                            onClose={handleCloseViewer}
                            onDelete={handlePhotoDeleted}
                        />
                    )}
                </>
            )}
        </div>
    );
}

export default App;
